<mat-sidenav-container class="page-container" autosize>
  <!-- Sidenav -->
  <mat-sidenav class="sidenav" [ngClass]="{'show-menu': showMenu}" [opened]="isLarge$ | async" [mode]="(isLarge$ | async) ? 'side' : 'over'" #sidenav #sidenavEl>
    <div class="menu-button-container">
      <button class="menu basic-button" (click)="toggleMenu()">
        <mat-icon class="icon material-icons-round">menu</mat-icon>
      </button>
    </div>

    <ul class="nav-list">
      <h3 class="headline">Pages</h3>
      <li *ngFor="let menuItem of menuService.mainMenu">
        <a class="text-decoration-none flex-center-vertical reset-visited-color"
           [routerLink]="menuItem.routerLink" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
          <mat-icon class="material-icons-round icon">{{menuItem.icon}}</mat-icon>
          <span>{{menuItem.name}}</span></a></li>

      <!-- If signed in -->
      <ng-container *ngIf="auth.user">
        <li>
          <a class="text-decoration-none flex-center-vertical reset-visited-color"
             [routerLink]="nav_path.newStory" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <mat-icon class="material-icons-round icon">history_edu</mat-icon>
            <span>Write Story</span></a></li>
        <li>
          <a class="text-decoration-none flex-center-vertical reset-visited-color"
             [routerLink]="nav_path.privateStories" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <mat-icon class="material-icons-round icon">library_books</mat-icon>
            <span>My Stories</span></a></li>
      </ng-container>

      <ng-container *ngIf="auth.isAdmin()">
        <section class="admin-route">
          <hr class="divider" />
          <li>
            <a class="text-decoration-none flex-center-vertical reset-visited-color"
               [routerLink]="[nav_path.admin]" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
              <mat-icon class="material-icons-round icon">admin_panel_settings</mat-icon>
              <span>Admin Dashboard</span>
            </a>
          </li>
        </section>
      </ng-container>
    </ul>

  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content>
    <section class="content">
      <!-- Header -->
      <anon-header [sidenav]="sidenav"></anon-header>

      <div class="outlet">
        <router-outlet></router-outlet>
      </div>

      <!-- Footer -->
      <anon-footer></anon-footer>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
